import { REQUEST_ADD_MEDIA, RECIEVE_ADD_MEDIA, UPDATE_ADD_MEDIA_VALUES, CLEAR_ADD_MEDIA_VALUES} from '../constants/actionTypes';
import { getBody, displayError } from './helpers';
import { getBackendUrl } from '../env';


// Action Creators
const requestAddMedia = scene => ({
    type: REQUEST_ADD_MEDIA,
    scene: scene
});

const receiveAddMedia = (scene, addedMedia) => ({
    type: RECIEVE_ADD_MEDIA,
    scene: scene,
    addedMedia: addedMedia
});

export const updateAddMediaFormValues = values => ({
    type: UPDATE_ADD_MEDIA_VALUES,
    values: values
});

export const clearAddMediaFormValues = () => ({
    type: CLEAR_ADD_MEDIA_VALUES
});

export const cleanupAddMedia = scene => ({
    type: REQUEST_ADD_MEDIA,
    scene: scene,
    cleanup: true
});

// Action Logic
export const addMedia = (scene, payload) => dispatch => {
    dispatch(requestAddMedia(scene));

    return fetch(`${getBackendUrl()}/api/v1/scene/${scene}`, {method: 'POST', body: JSON.stringify(payload), headers: {'Content-Type': 'application/json'}})
        .then(getBody)
        .then(json => dispatch(receiveAddMedia(scene, json)));
};

const canAddMedia = (values, state) => {
    return !state.isAdding && values.dataset && !isNaN(values.dataset);
};

export const addMediaIfOK = (scene, values) => (dispatch, getState) => {
    var sceneMediaDataState = getState().ui.addSceneMediaData;

    if (canAddMedia(values, sceneMediaDataState)) {
        const payload = {
            mediaPath: values.path,
            mediaRepository: values.repository,
            mediaName: values.mediaName,
            datasetNum: Number(values.dataset),
            language: values.language,
        };

        return dispatch(addMedia(scene, payload))
            .catch(err => {
                dispatch(cleanupAddMedia);
                dispatch(displayError(err));
            }
        ); 
    }
};



// WEBPACK FOOTER //
// ./src/actions/addMedia.js